"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
tslib_1.__exportStar(require("./DashboardExtensionContextProvider.decl"), exports);
tslib_1.__exportStar(require("./DashboardExtensionContextProvider"), exports);
//# sourceMappingURL=index.js.map